module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/miami-univ-7b44a90b52459840704a45449740278b.svg";